import { FieldRespondWithData } from '@/uikit'
import { faArrowToBottom, faFileAlt } from '@fortawesome/pro-regular-svg-icons'
import { ButtonIcon, Icon, Popover, State, Table, Toast } from '@seiue/ui'
import { downloadFile, isArray } from '@seiue/util'
import { UploadFile } from 'antd'
import { ChildFieldRes, FieldTypeEnum } from 'packages/sdks-next/growp'
import { AnyType } from 'packages/types'
import React, { useState } from 'react'
import styled from 'styled-components'
import { optionValueToLabel, urlRender } from './utils'
import { ColumnType } from 'antd/lib/table'

/**
 * 生源池数据在表格中的显示形式
 *
 * @param param - 参数
 * @param param.field - Object
 * @param param.text - 表格当前单元格的内容
 * @returns React.ReactNode
 */
export const ColumnsRender: React.FC<{
  field: FieldRespondWithData | ChildFieldRes
  text: AnyType
}> = ({ field, text }) => {
  const [loading, setLoading] = useState<boolean>(false)

  const fileDownload = async (name: string, url: string) => {
    try {
      setLoading(true)
      await downloadFile(name, url)
      setLoading(false)
    } catch (error) {
      Toast.warning('下载失败')
      setLoading(false)
    }
  }
  const { type, label, name, options } = field
  if (type === FieldTypeEnum.Attachment || name === 'avatar') {
    let dataSource = isArray(text) ? text : []
    if (name === 'avatar' && text) {
      dataSource = [
        {
          name: text.slice(text.lastIndexOf('/') + 1),
          url: text,
        },
      ]
    }
    const columns: ColumnType<AnyType>[] = [
      {
        title: label,
        key: 'name',
        dataIndex: 'name',
        render: (r: string, record: UploadFile) => {
          return (
            <AttachWrapper>
              <div>
                <Icon icon={faFileAlt} />
                <AttachNameWrapper
                  href={record.url}
                  target="_blank"
                >
                  {record.name}
                </AttachNameWrapper>
              </div>
              {loading ? (
                <State.Loading style={{ width: 10, minHeight: 10 }} />
              ) : (
                <ButtonIcon
                  icon={faArrowToBottom}
                  onClick={async () => {
                    await fileDownload(record.name, record.url || '')
                  }}
                />
              )}
            </AttachWrapper>
          )
        },
      },
    ]
    return (
      <Popover
        placement="topRight"
        title={
          <StyledTable
            columns={columns}
            dataSource={dataSource}
            rowKey={(r, i) => {
              return `${i}`
            }}
          />
        }
      >
        <AttachNumWrapper>{dataSource.length}</AttachNumWrapper>
      </Popover>
    )
  } else {
    const finalText = optionValueToLabel(text, type, options)
    const showText = isArray(finalText)
      ? finalText.join(',')
      : urlRender(finalText, type)
    return <>{showText}</>
  }
}

const AttachNumWrapper = styled.div`
  color: ${(props) => props.theme.brand._2};
  cursor: pointer;
`

const AttachNameWrapper = styled.a`
  color: ${(props) => props.theme.brand._2};
  cursor: pointer;
  margin: 0 10px;
`

const AttachWrapper = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StyledTable = styled(Table)`
  // 字段数据为空时显示-,暂时隐藏，勿删
  .ant-table-cell:empty:after,
  .ant-table-cell > span:empty:after {
    content: '-';
  }
  .ant-table-thead > tr > th {
    background-color: ${(props) => props.theme.background._4};
  }
  .ant-table-thead
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(
      .ant-table-row-selected
    )
    > td,
  .ant-table-tbody
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(
      .ant-table-row-selected
    )
    > td,
  .ant-table-thead
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr.ant-table-row.even-row:hover:not(.ant-table-row-selected)
    td {
    background: ${(props) => props.theme.background._4};
  }
  .ant-table-tbody > tr.ant-table-row.even-row:not(.ant-table-row-selected) td {
    background-color: transparent;
  }
  .ant-table-tbody > tr > td {
    border-color: ${(props) => props.theme.border.greyNormal};
  }
`
